module.exports = {"520102200":"后巢乡","520102201":"云关乡","520102202":"小碧布依族苗族乡","520102203":"永乐乡","520102400":"新华社区服务中心","520102401":"西湖社区服务中心","520102402":"水口寺社区服务中心","520102403":"大南社区服务中心","520102404":"中南社区服务中心","520102405":"市府社区服务中心","520102406":"河滨社区服务中心","520102407":"遵义社区服务中心","520102408":"兴关社区服务中心","520102409":"沙冲社区服务中心","520102410":"沙南社区服务中心","520102411":"太慈社区服务中心","520102412":"湘雅社区服务中心","520102413":"油榨社区服务中心","520102414":"中曹司社区服务中心","520102415":"二戈寨社区服务中心","520102416":"见龙社区服务中心","520102417":"龙洞社区服务中心","520102418":"花果园社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520102.json
// module id = 2261
// module chunks = 0